import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import {
  DestructiveButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { useDestructivePlusValidation } from '@grnhse/seedling/lib/birch/components/modals/';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import { RejectForm } from './reject_modal';
import { convertNumberToWords } from 'people/legacy/index/bulk_actions/utils';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'candidate_profile_redesign.modals.bulk_reject_confirmation'
);

type Props = {
  isOpen: boolean;
  close: () => void;
  applicationsToRejectInBulkCount: number;
  closeRejectModal: () => void;
  onSubmit: (values: RejectForm) => Promise<void>;
};

const BulkRejectConfirmationModal = ({
  isOpen,
  close,
  closeRejectModal,
  applicationsToRejectInBulkCount,
  onSubmit,
}: Props) => {
  const numToReject = applicationsToRejectInBulkCount;

  const { getValues } = useFormContext();

  const submit = async () => {
    await onSubmit(getValues() as RejectForm);
    closeRejectModal();
  };

  const confirmationPhrase = numToReject
    ? convertNumberToWords(numToReject)
    : null;

  const { errorStatus, value, setValue, setErrorStatus, confirmAction } =
    useDestructivePlusValidation(confirmationPhrase, async () => {
      submit();
      close();
      setErrorStatus(false);
    });

  return (
    <ConfirmationModal
      ariaLabel={t('title')}
      isOpen={isOpen}
      onDismiss={close}
      data-provides="bulk-reject-confirmation"
    >
      <ConfirmationModal.Header destructive>
        {t('title')}
      </ConfirmationModal.Header>
      <ConfirmationModal.Body>
        <Body>{t('body', { count: numToReject })}</Body>
        <TextInput
          required
          ariaLabelledBy={'text-confirmation-field'}
          label={t('confirmLabel', { phrase: confirmationPhrase })}
          error={errorStatus}
          helperText={errorStatus ? t('error') : undefined}
          onChange={(event: React.SyntheticEvent<HTMLInputElement>) =>
            setValue(event.currentTarget.value)
          }
          value={value}
        />
      </ConfirmationModal.Body>
      <ConfirmationModal.Footer>
        <DestructiveButton onClick={confirmAction}>
          {t('submit')}
        </DestructiveButton>
        <SecondaryButton onClick={close}>{t('cancel')}</SecondaryButton>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};

export default BulkRejectConfirmationModal;
